import {Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const itemSx = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: 70
};

const labelSx = {fontSize: "15px", color: "#B1B3B3", paddingRight: 1};
const valueSx = {fontSize: 15, fontWeight: "bold"};

// billConfidence holds a single value: either a text ("No Bill") or a hex color ("#28a745").
const isColorCode = (value) => /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(value);

/**
 * The claim header as an accordion: the header row is the summary, the claim info card
 * (passed as children) is the collapsible body. The parent owns `infoExpanded` so it can
 * close the accordion itself, e.g. when the vNeuron tab is opened.
 */
function ClaimViewHeader(props) {
    const {
        viewClaim,
        setClaimView,
        claimData,
        infoExpanded,
        setInfoExpanded,
        children
    } = props;

    const canToggle = typeof setInfoExpanded === "function";
    const billConfidence = typeof claimData?.billConfidence === "string"
        ? claimData.billConfidence.trim()
        : "";

    // claimData.stpStatus = 'Approved';
    return (
        <Accordion
            expanded={canToggle ? Boolean(infoExpanded) : true}
            onChange={(event, expanded) => canToggle && setInfoExpanded(expanded)}
            disableGutters
            TransitionProps={{unmountOnExit: true}}
            sx={{
                width: "100%",
                margin: "20px",
                borderRadius: "4px",
                "&:before": {display: "none"},
            }}
        >
            <AccordionSummary
                expandIcon={canToggle ? <ExpandMoreIcon/> : null}
                sx={{
                    padding: "0 16px",
                    "& .MuiAccordionSummary-content": {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        gap: "40px",
                        margin: "10px 0",
                    },
                }}
            >
                <Grid sx={itemSx}>
                    <Button
                        variant="contained"
                        style={{
                            padding: "10px",
                            background: viewClaim ? "" : "#fff",
                            color: viewClaim ? "" : "#1976d2",
                            border: viewClaim ? "" : "2px solid #1976d2",
                        }}
                        onClick={(event) => {
                            // A button inside the summary must not also toggle the accordion.
                            event.stopPropagation();
                            setClaimView(true);
                        }}
                        onFocus={(event) => event.stopPropagation()}
                    >
                        View Claim
                    </Button>
                </Grid>

                {/* <Grid style={{marginTop: 20}}>
                    <Button
                        variant="contained"
                        style={{
                            padding: "10px",
                            background: !viewClaim ? "" : "#fff",
                            color: !viewClaim ? "" : "#1976d2",
                            border: !viewClaim ? "" : "2px solid #1976d2",
                        }}
                        onClick={() => setClaimView(false)}
                    >
                        STP Details
                    </Button>
                </Grid> */}

                <Grid sx={itemSx}>
                    <Typography variant="h6" component="h2" sx={labelSx}>
                        Intimation Number:
                    </Typography>
                    <Typography variant="subtitle1" component="p" sx={valueSx}>
                        {claimData.intimationNumber}
                    </Typography>
                </Grid>

                {claimData?.stpStatus && claimData?.stpStatus.includes("APPROVED") &&
                    <Grid sx={itemSx}>
                        <Typography variant="h6" component="h2" sx={labelSx}>
                            Vitraya Response:
                        </Typography>
                        <Typography variant="subtitle1" component="p" sx={valueSx}>
                            {claimData?.stpStatus ? claimData?.stpStatus : "No STP"}
                        </Typography>
                    </Grid>
                }

                <Grid sx={itemSx}>
                    <Typography variant="h6" component="h2" sx={labelSx}>
                        Vitraya STP:
                    </Typography>
                    <Typography variant="subtitle1" component="p" sx={valueSx}>
                        {
                            !claimData?.stpStatus ||
                            claimData?.stpStatus === "NA" ||
                            claimData?.stpStatus.trim() === ""
                                ? ""
                                : claimData.stpStatus.includes("APPROVED")
                                    ? "ASTP"
                                    : claimData.stpStatus.includes("QUERY")
                                        ? "QSTP"
                                        : "NSTP"
                        }
                    </Typography>
                </Grid>

                {billConfidence &&
                    <Grid sx={itemSx}>
                        <Typography variant="h6" component="h2" sx={labelSx}>
                            Bill Confidence:
                        </Typography>
                        {isColorCode(billConfidence) ? (
                            <span style={{
                                display: "inline-block",
                                width: 16,
                                height: 16,
                                borderRadius: "50%",
                                background: billConfidence
                            }}/>
                        ) : (
                            <Typography variant="subtitle1" component="p" sx={valueSx}>
                                {billConfidence}
                            </Typography>
                        )}
                    </Grid>
                }
            </AccordionSummary>

            {children && (
                <AccordionDetails sx={{padding: "0 16px 16px", borderTop: "1px solid rgba(0, 0, 0, .08)"}}>
                    {children}
                </AccordionDetails>
            )}
        </Accordion>
    );
}

export default ClaimViewHeader;
